<template lang="html">
  <b-form role="form" @submit.prevent="onSubmit($event.target)" class="col-lg-9 col-page-content page-style-2">
    <div class="row">

      <div class="col-12">
        <div class="box-bubble">
          <div class="row">

            <div class="col-12 box-acc-title-s1">
              <h4>Perfil de Empresa</h4>
              <hr />
            </div>

            <b-form-group class="col-lg-12 custom-f-group-1" label="Nombre de la Empresa*" label-for="i-1">
              <b-form-input
                id="i-1"
                v-model="company_form.nombre"
                type="text"
                placeholder="Insumos Quirúrgicos"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Nombre(s)*" label-for="i-2">
              <b-form-input
                id="i-2"
                v-model="company_form.nombre_responsable"
                type="text"
                placeholder="Cecilia"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Apellidos*" label-for="i-3">
              <b-form-input
                id="i-3"
                v-model="company_form.apellido_responsable"
                type="text"
                placeholder="Gómez Fernandez"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Correo Electrónico*" label-for="i-4">
              <b-form-input
                id="i-4"
                v-model="company_form.email"
                type="email"
                placeholder="contacto@correo.com"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Teléfono*" label-for="i-5">
              <b-form-input
                id="i-5"
                v-model="company_form.telefono"
                type="number"
                placeholder="3311112222"
                
              ></b-form-input>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Sitio web*" label-for="i-6">
              <b-form-input
                id="i-6"
                v-model="company_form.sitio_web"
                type="text"
                placeholder="http://www.jobusco.com"
                
              ></b-form-input>
            </b-form-group>

            <!-- <b-form-group class="col-md-6 custom-f-group-1" label="Sector*" label-for="i-7">
              <b-form-select id="i-7" required v-model="company_form.sector" multiple>
                <b-form-select-option :value="null" disabled>Seleccione una opción</b-form-select-option>
                <b-form-select-option :value="area.id" v-for="area in areasOpcs" :key="area.id">{{area.nombre}}</b-form-select-option>
              </b-form-select>
            </b-form-group> -->

            <b-form-group class="col-md-6 custom-f-group-1" label="Sector*" label-for="i-7">
                <b-form-group
               
                label-for="i-6">
                <v-select v-model="company_form.categorias" :options="areasOpcs" label="nombre" index="id" multiple/>
              </b-form-group>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="URL maps" label-for="i-6">
              <b-form-input
                id="i-6"
                v-model="company_form.url_maps"
                type="text"
                
              ></b-form-input>
            </b-form-group>


            <b-form-group class="col-lg-12 custom-f-group-1" label="Descripción del perfil Corporativo*" label-for="i-8">
              <editor
                v-model="company_form.descripcion"
                 api-key="voyk5grgw5zv5ueomjptgwscn9vyw7a0sifs0oy5fxj4befk"
                 :init="{
                   height: 265,
                   menubar: false,
                   language: 'es_MX',
                   paste_block_drop: false,
                   paste_as_text: !0,
                   entity_encoding: 'raw',
                   plugins: [
                     'advlist autolink lists link image charmap print preview anchor',
                     'searchreplace visualblocks code fullscreen',
                     'insertdatetime media table paste code help wordcount'
                   ],
                   toolbar:
                     'undo redo | formatselect | bold italic backcolor | \
                     alignleft aligncenter alignright alignjustify | \
                     bullist numlist outdent indent | removeformat'
                 }"
              />
            </b-form-group>


            <b-form-group class="col-lg-12 custom-f-group-1" label="Valores*" label-for="i-8">
              <editor
                v-model="company_form.valores"
                 api-key="voyk5grgw5zv5ueomjptgwscn9vyw7a0sifs0oy5fxj4befk"
                 :init="{
                   height: 265,
                   menubar: false,
                   language: 'es_MX',
                   paste_block_drop: false,
                   paste_as_text: !0,
                   entity_encoding: 'raw',
                   plugins: [
                     'advlist autolink lists link image charmap print preview anchor',
                     'searchreplace visualblocks code fullscreen',
                     'insertdatetime media table paste code help wordcount'
                   ],
                   toolbar:
                     'undo redo | formatselect | bold italic backcolor | \
                     alignleft aligncenter alignright alignjustify | \
                     bullist numlist outdent indent | removeformat'
                 }"
              />
            </b-form-group>
          </div>
        </div>

        <div class="mt-4 box-bubble">
          <div class="row">

            <div class="col-12 box-acc-title-s1">
              <h4>Dirección</h4>
              <hr />
            </div>

            <b-form-group class="col-md-6 custom-f-group-1" label="País*" label-for="i-9">
              <b-form-select id="i-9"  v-model="company_form.pais_id">
                <b-form-select-option :value="null" disabled>Seleccione una opción</b-form-select-option>
                <b-form-select-option value="mx">México</b-form-select-option>
                <b-form-select-option value="usa">USA</b-form-select-option>
              </b-form-select>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Estado*" label-for="i-10">
              <b-form-select id="i-10" required v-model="company_form.estado_id">
                <b-form-select-option :value="null" disabled>Seleccione una opción</b-form-select-option>
                <b-form-select-option :value="state.id" v-for="state in statesOpcs" :key="state.id">{{state.name}}</b-form-select-option>
              </b-form-select>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Ciudad*" label-for="i-11">
              <b-form-select id="i-11" required v-model="company_form.ciudad_id">
                <b-form-select-option :value="null" disabled>Seleccione una opción</b-form-select-option>
                <b-form-select-option :value="town.id" v-for="town in townsOpcs" :key="town.id">{{town.name}}</b-form-select-option>
              </b-form-select>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Código Postal*" label-for="i-12">
              <b-form-input
                id="i-12"
                v-model="company_form.cp"
                type="number"
                placeholder="Código Postal"
                
              ></b-form-input>
            </b-form-group>

            <b-form-group class="col-lg-12 custom-f-group-1" label="Dirección completa*" label-for="i-13">
              <b-form-input
                id="i-13"
                v-model="company_form.domicilio"
                
                placeholder="Calle, número, colonia"
                
              ></b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="mt-4 box-bubble">
          <div class="row">

            <div class="col-12 box-acc-title-s1">
              <h4>Redes sociales</h4>
              <hr />
            </div>

            <b-form-group class="col-md-4 custom-f-group-1" label="Facebook*" label-for="i-14">
              <b-form-input
                id="i-14"
                v-model="company_form.facebook"
                type="text"
                placeholder="#"
                
              ></b-form-input>
            </b-form-group>

            <b-form-group class="col-md-4 px-md-1 custom-f-group-1" label="Twitter*" label-for="i-15">
              <b-form-input
                id="i-15"
                v-model="company_form.twitter"
                type="text"
                placeholder="#"
                
              ></b-form-input>
            </b-form-group>

            <b-form-group class="col-md-4 custom-f-group-1" label="LinkedIn*" label-for="i-16">
              <b-form-input
                id="i-16"
                v-model="company_form.linkedin"
                type="text"
                placeholder="#"
                
              ></b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="mt-2 px-0 box-empty-bubble">
          <b-form-checkbox
            v-model="company_form.check"
            class="mb-3 custom-checkbox-s1"
            name="checkbox-1"
            value="accepted"
            unchecked-value="not_accepted"
            required>
            Al hacer clic en la casilla de verificación, acepta nuestros <a @click="openedModal = 'terminos'" href="#">Términos y condiciones</a> y <a href="#" @click="openedModal = 'aviso'">Política de privacidad</a>
          </b-form-checkbox>
          <b-button type="submit" class="btn-HelvNeu btn-squ-cur-1 btn-send">Guardar perfil</b-button>
          
        </div>
       
      </div>

    </div>
    <sweet-modal ref="modalLoading" hide-close-button blocking>

        <img src="/public/images/shared/loading.gif" width="30%">
        <p style="text-align: center;"><b>Cargando...</b></p>
    </sweet-modal>
    <sweet-modal ref="modalAlert" :icon="modal.icon">
          <p>{{modal.msg}}</p>
           <br><br>
          <a class="btn btn-info" @click="$refs.modalAlert.close()">Aceptar</a>
    </sweet-modal>
    <modalaviso-component></modalaviso-component>
    <!--  -->

    <!-- Modal terminos-->
    <modalterminos-component></modalterminos-component>
    <!--  -->
  </b-form>
  

</template>

<script>
import Editor from '@tinymce/tinymce-vue';
import modalavisoComponent from '../modals/modal-aviso-privacy.vue';
import modalterminosComponent  from '../modals/modal-terminos.vue';
export default {
  data(){
    return{
      company_form: {
          check:'not_accepted'
      },
      modal:{
          icon:null,
          msg:null
      },
      statesOpcs:[],
      townsOpcs:[],
      areasOpcs:[],

    }
  },
  watch:{
      'company_form.estado_id':function(val){
          this.getTownsOpcs(val);
      },      
  },
  methods: {
      onSubmit(form) {
        //event.preventDefault();
        this.$refs.modalLoading.open();
        //event.preventDefault();
        var data=tools.params(form,this.company_form);
    
        axios.post(tools.url("/api/admin/company/updateProfileFront"),data).then((response)=>{
            this.$root.auth();
            this.$refs.modalLoading.close();
            this.modal.icon = 'success';
            this.modal.msg = 'información actualizada correctamente';
            this.$refs.modalAlert.open();

            
        }).catch((error)=>{
            this.$refs.modalLoading.close();
            this.modal.icon = 'error';
            this.modal.msg = 'Ocurrio un error al guardar la información';
            this.$refs.modalAlert.open();

        });
      },
      getStatesOpcs(){
        axios.get(tools.url("/states")).then((response)=>{
            this.statesOpcs = response.data;
          }).catch((error)=>{
          });
      },
      getTownsOpcs(state_id){
        axios.get(tools.url("/cities/"+state_id)).then((response)=>{
            this.townsOpcs = response.data;
          }).catch((error)=>{
          });
      },
      getCategories(){
          axios.get(tools.url("/categoriesFront"))
          .then((response)=>{
              this.areasOpcs = response.data;
          }).catch((error)=>{
            
          });
      },

  },
  mounted(){
      this.getCategories();
      this.getStatesOpcs();
      
      this.company_form = this.$root.user.usercompany;
      this.company_form.categorias = this.$root.user.categorias_ids;
      this.company_form.check = 'not_accepted';
  },
  components: {
    'editor': Editor,modalavisoComponent,modalterminosComponent
  },
}
</script>
